import { OptionsApi } from '@core/swagger-client';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/$webinarId/content')({
    // As the overview: the page is complete on the first render, so a back link restores its scroll position.
    loader: {
        handler: async ({ context, params }) => {
            if (!context.isAuthenticated) return;
            await context.queryClient.ensureQueryData(OptionsApi.dashboard.getContentSummary(params.webinarId)).catch(() => undefined);
        },
        staleReloadMode: 'blocking'
    }
});
